import { quoteOrTabRemoved } from 'epic/workspace/common/tabs/tabsEpics/quoteOrTabRemoved';
import type { RegulatoryDocument } from 'models/streaming';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { EMPTY, merge, of } from 'rxjs';
import { catchError, filter, map, mergeMap, takeUntil, timeoutWith } from 'rxjs/operators';
import { dynamicKidDocumentReceivedThunk, dynamicKidDocumentTimeoutThunk } from 'state/dynamic/dynamicForm.thunks';
import { isQuoteTypeWithRegulation } from 'state/quotes/utils';
import type { EpicWithThunk } from 'state/state.common';
import { fatEventApiConnector } from 'utils/streaming/api';
import { kidDocuments } from 'utils/streaming/messages';

// TODO catch Error in Epic
export function kidDocumentEpic(appScheduler?: SchedulerLike): EpicWithThunk {
  return (action$, state$, { oldHttpClient, getSgmeConfiguration, streaming }) =>
    action$.pipe(
      ofType('QUOTE_ACKED'),
      filter(x => x.workspace === 'dynamic' && isQuoteTypeWithRegulation(x.quoteType)),
      mergeMap(({ tabId, quoteId }) => {
        const success$ = action$.pipe(
          ofType('KID_DOCUMENT_RECEIVED'),
          filter(x => x.quoteId === quoteId && x.workspace === 'dynamic'),
          filter(x => (Array.isArray(x?.rejections) && x.rejections.length === 0) || x?.rejections === undefined),
        );
        const kidTimeoutMs = getSgmeConfiguration().kidTimeoutMs;
        const quoteOrTabRemoved$ = quoteOrTabRemoved(action$, tabId, quoteId, state$);
        return kidDocuments(streaming).pipe(
          filter(x => x.quoteId === quoteId),
          mergeMap(lightEvent =>
            fatEventApiConnector(oldHttpClient)
              .getFatEvent<RegulatoryDocument>(lightEvent)
              .pipe(
                catchError(_ => EMPTY),
                map(doc => dynamicKidDocumentReceivedThunk(tabId, quoteId, doc)),
              ),
          ),
          takeUntil(merge(success$, quoteOrTabRemoved$)),
          timeoutWith(kidTimeoutMs, of(dynamicKidDocumentTimeoutThunk(tabId, quoteId)), appScheduler),
        );
      }),
    );
}
